import React from "react";
import { GREEN_LIGHT } from '../../styles/shared/colors';

const getInputWidth = value => {
  if (value === null) {
    return '';
  };

  if (parseInt(value,10) > 99) {
    return '50px';
  };

  return '35px';
};

const SingleInput = ({ scoreType ,score, isOnFocus, handleFocus, handleBlur, updateValue, isEditable }) => {
  const width = getInputWidth(score);

  return (
    <div className="game-score-inputs__single-input"
      style={{
        filter: !isEditable && 'brightness(100%)',
        justifyContent: score === null && 'center'
      }}
    >
      <span
        className="game-score-inputs__single-input__text"
        style={{ color: (score !== null || isOnFocus) && GREEN_LIGHT}}
      >
        {scoreType}
      </span>
      <input
        value={score}
        disabled={!isEditable}
        type='number'
        className="game-score-inputs__single-input__input"
        style={{
          width,
          maxWidth: width,
          cursor: !isEditable && 'initial'
        }}
        onChange={({ target: { value } }) => updateValue(value, scoreType)}
        onFocus={() => handleFocus(scoreType)}
        onBlur={({ target: { value } }) => handleBlur(scoreType, value)}
      />
    </div>
  );
};

export default SingleInput;
